<template>
  <div class="container">
    <div class="row">
      <div class="col m8 s12 offset-m2">
        <div class="card">
          <div class="card-image">
            <img id="image" :src="qr" v-on:load="loaded()">
            <div id="progress" class="valign-wrapper">
                <div class="preloader-wrapper active" style="margin: auto">
                  <div class="spinner-layer spinner-red-only">
                    <div class="circle-clipper left">
                      <div class="circle"></div>
                    </div><div class="gap-patch">
                      <div class="circle"></div>
                    </div><div class="circle-clipper right">
                      <div class="circle"></div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div class="card-content">
            <span class="card-title">New device</span>
            <p>Scan the QR-code with the Helen-app to activate the new device.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
#image{
  opacity: 0;
  transform: scale(0);
  transition: 0.6s ease-in-out;
}
#progress{
  width: 100%;
  height: 600px;
}
</style>
<script>
  export default {
    name: 'devices',
    data() {
      return {
        qr: ""
      }
    },
    methods: {
      loaded(){
        progress.style.display = "none";
        image.style.opacity = 1;
        image.style.transform = "scale(1)";
      },
      getQR() {
        this.$http({
            method: "post",
            url: "auth/qrhelen",
            data: {
              "languages": 1,
              "dialogs": 1,
              "phrases": 1,
              "settings": 1,
              "userrecord": 1,
              "stats": 2,
              
            },
            responseType: "blob"
          })
          .then(response => {
            var reader = new window.FileReader();
            reader.readAsDataURL(response.data);
            reader.onload = () => {
              this.qr = reader.result
            }
          });

      }
    },
    created() {
      this.getQR();
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Devices.vue